module.exports = __webpack_public_path__ + "static/img/nan.9aad773.png";